import {
	getGiraRequestOptions,
	getGiraUrl,
} from '@atlassian/jira-issue-fetch-services-common/src/services/issue-gira-data/index.tsx';
import { IssueViewFetchOperations } from '@atlassian/jira-issue-fetch-services-common/src/types.tsx';
import fetchJson from '../../common/utils/fetch-json.tsx';

export const fetchIssueGiraData = (issueKey: string, projectKey: string) =>
	fetchJson(
		getGiraUrl(IssueViewFetchOperations.EARLY_FETCH_GIRA),
		getGiraRequestOptions(issueKey, projectKey),
	);
